import { ModInfo } from './mod';

export interface AppData {
  mods: ModInfo[];
  v0: string[];
  hash: string[];
}
